import React, { useState, useEffect } from 'react';
import apiHelper from '../utils/apiHelper';
import { format, parseISO } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faUser, faClock } from '@fortawesome/free-solid-svg-icons';
import './ActivityLog.css';

function ActivityLog() {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchActivityLogs();
    }, []);

    const fetchActivityLogs = async () => {
        try {
            const response = await apiHelper.get('/api/graph/getActivityLogs');
            const sortedActivities = response.data.activities.sort((a, b) => {
                const dateA = parseISO(a.fields.ActionTimestamp);
                const dateB = parseISO(b.fields.ActionTimestamp);
                return dateB - dateA;
            });
            setActivities(sortedActivities);
            setLoading(false);
        } catch (err) {
            setError('Failed to load activity logs');
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <FontAwesomeIcon icon={faSpinner} spin />
                <span>Loading activity logs...</span>
            </div>
        );
    }

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <div className='totalPage'>
            <section className="wrapper">
                <div className="container reveal reveal-delay-1 tabs-container">
            <h2>Activity Log</h2>
            <div className="activity-list">
                {activities.map((activity) => (
                    <div key={activity.id} className="activity-item">
                        <div className="activity-header">
                            <span className="user-info">
                                <FontAwesomeIcon icon={faUser} />
                                {activity.fields.UserName}
                            </span>
                            <span className="timestamp">
                                <FontAwesomeIcon icon={faClock} />
                                {format(new Date(activity.fields.ActionTimestamp), 'PPpp')}
                            </span>
                        </div>
                        <div className="activity-details">
                            <strong>{activity.fields.ActionType}</strong>
                            <p>{activity.fields.ActionDetails}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
         
        </section>
        </div>
    );
}

export default ActivityLog; 